import axios from 'axios';
import auth from '../auth';

const mediaStoreUrl = process.env.KMB_MEDIA_STORE_URL;
let source;

const getConfig = () => ({
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${auth.token.get()}`,
  },
});

const uploadPostImage = ({ imageFile, thumbFile, userId, onProgress = null }) => {
  const formData = new FormData();
  const config = getConfig();
  const CancelToken = axios.CancelToken;
  source = CancelToken.source();

  config.onUploadProgress = onProgress;
  config.cancelToken = source.token;

  formData.append('files[0]', imageFile, imageFile.name);
  formData.append('files[1]', thumbFile, thumbFile.name);

  return axios.post(
    `${mediaStoreUrl}/v1/medias/upload_community_user_post_image?user_id=${userId}`,
    formData,
    config,
  );
};

export default {
  uploadPostImage,
};



// WEBPACK FOOTER //
// ./src/helpers/request/communityMedia.js